import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import MegaMenu from '../customer_pages/_megamenu/mega-menu';

document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById('menu');

  const props = JSON.parse(root.dataset.props);

  hydrateRoot(root, <MegaMenu {...props} />);
});
